/**
 * @generated SignedSource<<486bdca36fbd0b58abc3396ac20f3e7a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useRenderBlurbs_displayInfo$data = {
  readonly pricing: {
    readonly showSold: boolean | null;
    readonly showUnavailable: boolean | null;
  } | null;
  readonly " $fragmentType": "useRenderBlurbs_displayInfo";
};
export type useRenderBlurbs_displayInfo$key = {
  readonly " $data"?: useRenderBlurbs_displayInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"useRenderBlurbs_displayInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useRenderBlurbs_displayInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PriceInfoDisplay",
      "kind": "LinkedField",
      "name": "pricing",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showSold",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showUnavailable",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemDisplayInfo",
  "abstractKey": null
};

(node as any).hash = "ee1bebb07343b926bdc1513cc23ae5b4";

export default node;
